import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import './Style/SubjectTopics.css';
import PdfFiles from "../AllData/PdfFiles";
import StudyOption from "../AllData/HomeData";
import TopNavbar from "../home/TopNavbar";
import TopHeader from "../home/TopHeader";


function AllSubjectTopics({ subject, type }) {
  const allPdfs = PdfFiles;
  const [pdfs, setPdfs] = useState([]);
  const [bookmarkedPdfs, setBookmarkedPdfs] = useState([]);
  const [dounloadPdfs, setDounloadPdfs] = useState([]);
  const studyOptions = StudyOption;
  const matchingItem = studyOptions?.find(item => item.id === type);
  const iconName = matchingItem ? matchingItem.symbol : '📝';

 




  useEffect(() => {
    const fetchData = () => {
      try {
        const filteredPdfs = allPdfs.filter(pdf =>
          pdf.subject === subject && pdf.type === type
        );
        setPdfs(filteredPdfs);

        const storedBookmarks = localStorage.getItem('pdfBookmarks');
        if (storedBookmarks) {
          const bookmarksData = JSON.parse(storedBookmarks);
          setBookmarkedPdfs(bookmarksData);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [allPdfs, subject, type]);

  useEffect(() => {
    const storedDounloadPdfs = JSON.parse(localStorage.getItem('savePdfIdInLocalStorage')) || [];
    setDounloadPdfs(storedDounloadPdfs);
  }, []);

  const toggleBookmark = (pdf) => {
    const isBookmarked = bookmarkedPdfs.some(
      bookmark => bookmark.pdfId === pdf.id
    );

    const storedBookmarks = localStorage.getItem('pdfBookmarks');
    let allBookmarks = storedBookmarks ? JSON.parse(storedBookmarks) : [];

    if (isBookmarked) {
      // Remove bookmark based only on pdfId
      const updatedBookmarks = allBookmarks.filter(
        bookmark => bookmark.pdfId !== pdf.id
      );
      localStorage.setItem('pdfBookmarks', JSON.stringify(updatedBookmarks));
      setBookmarkedPdfs(updatedBookmarks);
    } else {
      // Add bookmark without userId
      const newBookmark = {
        pdfId: pdf.id,
        subject: pdf.subject,
        pdfData: pdf,
        timestamp: new Date().toISOString()
      };

      const updatedBookmarks = [...allBookmarks, newBookmark];
      localStorage.setItem('pdfBookmarks', JSON.stringify(updatedBookmarks));
      setBookmarkedPdfs(updatedBookmarks);
    }
  };


  return (
    <div className="subject-topics-page">
      <TopNavbar name={subject.charAt(0).toUpperCase() + subject.slice(1)} />
      <TopHeader name={subject.charAt(0).toUpperCase() + subject.slice(1)} />

      <div className="subject-categories">

        {pdfs.map((pdf) => {
          const isBookmarked = bookmarkedPdfs.some(
            bookmark => bookmark.pdfId === pdf.id
          );
          const isPdfDounloaded = dounloadPdfs.some(
            dounloadedpdf => dounloadedpdf === pdf.id
          );

          return (
            <>



                <div className={`topic-card ${isBookmarked ? 'bookmarked' : ''}`} key={pdf.id}>

                  {isPdfDounloaded ? (
                    <div className="link">
                      <Link to={`/pdfviewer/${pdf.id}`} className="pdf-link" >
                        <p> {iconName} {pdf.name.length > 31 ? `${pdf.name.substring(0, 28)}...` : pdf.name} </p>
                        <p style={{ background: "blue", color: "white", padding: "4px", paddingLeft: "6px", paddingRight: "6px", borderRadius: "5px" }}>Open</p>
                      </Link>
                      <hr style={{ margin: "3px", }} className="hrline"></hr>
                      <p style={{ fontSize: "10px", color: "green" }}>Downloaded</p>
                      <div className="bookmark-icon" onClick={() => toggleBookmark(pdf)} title={isBookmarked ? "Remove bookmark" : "Add bookmark"}  >
                        {isBookmarked ? <p className="bookmarked-text">Saved</p> : <p className="bookmark-text">Save</p>}
                        {isBookmarked ? '★' : '☆'}
                      </div>
                    </div>

                  ) : (
                    <div className="link">
                      <Link to={`/pdfviewer/${pdf.id}`} className="pdf-link" >
                        <p> {iconName} {pdf.name.length > 31 ? `${pdf.name.substring(0, 28)}...` : pdf.name} </p>
                        <p style={{ background: "blue", color: "white", padding: "4px", paddingLeft: "6px", paddingRight: "6px", borderRadius: "5px" }}>Open</p>
                     </Link>
                      <hr style={{ margin: "3px", }} className="hrline"></hr>

                      <p style={{ fontSize: "10px", color: "#ff847b" }}>Not download</p>
                      <div className="bookmark-icon" onClick={() => toggleBookmark(pdf)} title={isBookmarked ? "Remove bookmark" : "Add bookmark"}  >
                        {isBookmarked ? <p className="bookmarked-text">Saved</p> : <p className="bookmark-text">Save</p>}
                        {isBookmarked ? '★' : '☆'}
                      </div>
                    </div>

                  )}
                </div>

             
            </>
          );
        })}

      </div>
    </div >
  );
}

export default AllSubjectTopics;